import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, DecimalPipe, AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid';
import { Observable } from 'rxjs';

export interface QuantityCellRendererParams {
  UMPActive$: Observable<boolean>;
  type: string | null;
  onOpenBatchesDetail?: (data: any) => void;
}

/**
 * Quantity Cell Renderer for Summary Material Grid
 *
 * Displays quantity information with:
 * - Base quantity (UMB) with unit
 * - Parallel quantity (UMP) with unit (if UMPActive)
 * - Batches detail button (if not load type)
 */
@Component({
  selector: 'app-quantity-cell-renderer',
  standalone: true,
  imports: [CommonModule, AsyncPipe, DecimalPipe, MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <div class="flex items-start gap-2">
      <div class="flex-1">
        <div class="text-sm">
          <span class="font-semibold">UMB:</span>
          {{ params?.data?.baseQuantity | number: '1.3' }}
          <span class="text-gray-500">
            ({{ params?.data?.baseUnitOfMeasure?.name ?? '-' }})
          </span>
        </div>

        <div class="text-sm" *ngIf="(customParams?.UMPActive$ | async)">
          <span class="font-semibold">UMP:</span>
          <ng-container *ngIf="params?.data?.pararellUnitOfMeasure; else noUMP">
            {{ params?.data?.pararellQuantity | number: '1.3' }}
            <span class="text-gray-500">
              ({{ params?.data?.pararellUnitOfMeasure?.name }})
            </span>
          </ng-container>
          <ng-template #noUMP>
            <span class="text-gray-500">-</span>
          </ng-template>
        </div>
      </div>

      <div *ngIf="customParams?.type !== 'DT003'" class="flex items-start">
        <button
          mat-icon-button
          color="primary"
          (click)="onBatchesClick($event)"
          matTooltip="Ver lotes">
          <mat-icon fontIcon="science"></mat-icon>
        </button>
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class QuantityCellRendererComponent implements CellRenderer<any>, OnInit {
  @Input() params!: CellRendererParams<any>;

  get customParams(): QuantityCellRendererParams | undefined {
    return this.params?.colDef?.cellRendererParams as QuantityCellRendererParams;
  }

  ngOnInit() {
    // Component initialized
  }

  onBatchesClick(event: Event): void {
    event.stopPropagation();
    if (this.customParams?.onOpenBatchesDetail && this.params?.data) {
      this.customParams.onOpenBatchesDetail(this.params.data);
    }
  }
}
